import { faMinusCircle, faPlusCircle, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";

/**
 * 校园招聘
 */
const Details = () => {
  const [item, setItem] = useState(0);
  const [favorite_id, setFavoriteId] = useState(0);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [schedule, setSchedule] = useState(false);
  const { id } = useParams();
  const { search } = useLocation();

  useEffect(() => {
    fetch(`/api/bulletin/${id}?option=campus`)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(404);
      })
      .then((data) => {
        if (data) {
          setItem(data);
          if (document.getElementById("content") !== null) {
            document.getElementById("content").innerHTML = data.content;
          }
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: id,
            ref_uuid2: data.uuid,
            category: "浏览校园招聘",
            tag: "个人用户",
          });
        }
      })
      .catch((err) => window.console.error(err));

    if (auth !== null) {
      const url = [
        "/api/miscellaneous/favorite",
        "?option=by-ref_id-ref_id2-category-tag",
        `&ref_id=${auth.id}`,
        `&ref_id2=${id}`,
        "&category=校园招聘",
        "&tag=个人用户",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) setFavoriteId(data[0].id);
        });

      fetch(`/api/common-user-schedule/user/${auth.id}/${id}`)
        .then((res) => res.json())
        .then((res) => {
          setSchedule(res.content);
        });
    }
  }, [id, search]);

  const handleFavorite = () => {
    if (auth) {
      if (favorite_id > 0) {
        fetch(`/api/miscellaneous/favorite/${favorite_id}`, {
          method: "DELETE",
        }).then((response) => {
          if (response.status === 200) setFavoriteId(0);
        });
      } else {
        fetch("/api/miscellaneous/favorite", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            ref_id: auth.id,
            ref_id2: id,
            category: "校园招聘",
            tag: "个人用户",
            ref_uuid: auth.uuid,
            ref_uuid2: item.uuid,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.insertId > 0) setFavoriteId(data.insertId);
          });
      }
    } else {
      location.href = `#登录?id=${id}`;
    }
  };

  const handleSchedule = () => {
    if (auth) {
      fetch("/gin-api/candidate-schedule", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          refId: auth.id.toString(),
          ref1Id: id,
        }),
      }).then((response) => {
        if (response.status === 200 || response.status === 201) {
          saveJournal({
            ref_id: auth.id,
            ref_id2: item.id,
            category: "添加日程",
            tag: "个人用户",
            ref_uuid: auth.uuid,
            ref_uuid2: item.uuid,
          });
          setSchedule(true);
          // setSchedule({ id: res.content });
        }
      });
      // fetch('/api/common-user-schedule/', {
      //   method: 'POST',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify({
      //     common_user_id: auth.id,
      //     campus_id: id,
      //     name: item.title,
      //   }),
      // })
      //   .then((res) => res.json())
      //   .then((res) => {
      //     console.log(res);
      //     saveJournal({
      //       ref_id: auth.id,
      //       ref_id2: item.id,
      //       category: '添加日程',
      //       tag: '个人用户',
      //       ref_uuid: auth.uuid,
      //       ref_uuid2: item.uuid,
      //     });
      //     setSchedule({ id: res.content });
      //   });
    } else {
      location.href = "#登录";
    }
  };

  const deleteSchedule = () => {
    if (auth) {
      fetch(`/gin-api/candidate-schedule/${auth.id}/${schedule.id}`, {
        method: "DELETE",
      }).then((response) => {
        if (response.status === 200) {
          saveJournal({
            ref_id: auth.id,
            ref_id2: item.id,
            category: "移除日程",
            tag: "个人用户",
            ref_uuid: auth.uuid,
            ref_uuid2: item.uuid,
          });
          setSchedule(false);
        }
      });
      // fetch(
      //   `/api/common-user-schedule/${schedule.id}?d=${id}&uuid=${auth.uuid}&u=${auth.id}`,
      //   {
      //     method: 'DELETE',
      //   },
      // )
      //   .then((res) => res.json())
      //   .then(() => {
      //     saveJournal({
      //       ref_id: auth.id,
      //       ref_id2: item.id,
      //       category: '移除日程',
      //       tag: '个人用户',
      //       ref_uuid: auth.uuid,
      //       ref_uuid2: item.uuid,
      //     });
      //     setSchedule(false);
      //   });
    } else {
      location.href = "#登录";
    }
  };

  const favoriteIcon = () => {
    if (favorite_id) {
      return <FontAwesomeIcon icon={faStar} style={{ color: "#FFFF00" }} fixedWidth />;
    }
    return <FontAwesomeIcon icon={faStar} fixedWidth />;
  };

  const scheduleButton = () => {
    if (schedule) {
      return (
        <button type="button" className="btn btn-danger nav-btn" onClick={deleteSchedule}>
          <FontAwesomeIcon icon={faMinusCircle} fixedWidth />
          移出日程
        </button>
      );
    }
    return (
      <button type="button" className="btn btn-success nav-btn" onClick={handleSchedule}>
        <FontAwesomeIcon icon={faPlusCircle} fixedWidth />
        加入日程
      </button>
    );
  };

  return (
    <>
      <div className="container-fluid" style={{ fontSize: 14 }}>
        <div className="card border-0 shadow mt-2 interface-bottom">
          <ToBack category={item.title} />
          <div className="card-body">
            <div className="row">
              <div className="col strong-center">
                <strong>{item.title}</strong>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
              </div>
            </div>

            <div className="row">
              <div className="col">
                举办方:
                {item.school}
              </div>
            </div>
            <div className="row">
              <div className="col">
                举办时间: {item.date} {item.time}
              </div>
            </div>
            <div className="row">
              <div className="col">
                举办地点: {item.address_level1}-{item.address_level2}-{item.address_level3}
                <br />
                {item.address_level4}
              </div>
            </div>
            <div className="row">
              <div className="col">简介:</div>
            </div>
            <div className="row ">
              <div className="col editor-body" id="content" />
            </div>
          </div>
        </div>
      </div>
      <div className="recommond-bottom" />
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button
            type="button"
            className="btn btn-light nav-btn text-muted"
            onClick={handleFavorite}
          >
            {favoriteIcon()}
            收藏
          </button>
        </div>
        <div className="col-4 nav-col">{scheduleButton()}</div>
      </ul>
    </>
  );
};

export default Details;
